module.exports = __webpack_public_path__ + "static/media/instructivom3.5282c5b2.png";